import Backbone from 'backbone';

import ParseService from '~/services/parseService';
import Model from '~/models/parseModel';
import Collection from '~/collections/parseCollection';
import toastr from 'toastr';

/**
 * @member [reportCommentsService] reportCommentsService
 */
var reportCommentsService;

/**
 * Object Picture service, manages pictures
 * @module services/reportCommentsService
 * @returns [reportCommentsService]
 */

export default function () {

    /**
     * Assigns ReportComments class with properties
     * @member [ReportComments] ReportCommentsModel
     */
    var ReportCommentsModel = Model.extend({
        className: "ReportComments",
        defaults: {
            'manualTitle': false,
        }
    });

    /**
     * Represents a collection of ReportComments
     * @member [ReportComments collection] ReportCommentCollection
     */
    var ReportCommentCollection = Collection.extend({
        model: ReportCommentsModel
    });

    /**
     * it's ReportCommentsModel service, object type service of the collection
     * @member [ReportComments Service] ReportCommentsService
     */
    var ReportCommentsService = ParseService.extend({
        sortBy: 'createdAt',
        order: 'dsc',
        model: ReportCommentsModel,
        collection: ReportCommentCollection,
		setInternComment:function(reportID, user,comment,xl){
			var Interncomment = Parse.Object.extend("ReportComments");
			var interncomment = new Interncomment();
			interncomment.set("report",reportID);
			interncomment.set("comment",comment);
			interncomment.set("auditor",true);
			interncomment.save(null, {
				success: function(interncomment) {
					window.createCommentResponse = interncomment;
					xl();
                    Parse.Cloud.run("SendCommentEmail", {comment: comment, reportId: reportID.objectId, commentId: interncomment.id}).then((r) => {
                        //console.log("Email sent: "+r);
                    }).catch(e => {
                        //console.log(e);
                    });
				},
				error: function(interncomment, error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
                        default:
                            if(arrlang[lang][error.message]){
                                toastr.error(arrlang[lang][error.message], "Error");
                            }
                            else{
                                toastr.error(arrlang[lang]['NewReportCommentError'],'Error');
                            }
                        break;
					}
				}
			});
		},
        // you can also extend any method from ParseService here
    });

    return reportCommentsService || (reportCommentsService = new ReportCommentsService());
};
// only created once for application
